<template>
    <div class="documentation">
        <div class="row">
            <div class="col-md-5">
                <Breadcumb :title="$t('invite_user')" :breadcumb-data="breadcumbData"></Breadcumb>
            </div>
        </div>
        <b-card class="cardcontainer">
            <b-form @submit="addUser">
                <span style="color:#ff0000" v-if="error">{{ error }}</span>
                <b-form-group :label="$t('name')" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                    <b-input type="text" :placeholder="$t('name')" v-model="lastname" :state="errors['lastname'] ? 'invalid': ''"/>
                    <div v-if="errors['lastname']" class="invalid-tooltip">{{ errors['lastname'][0] }}</div>
                </b-form-group>
                <b-form-group :label="$t('firstname')" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                    <b-input type="text" :placeholder="$t('firstname')" v-model="firstname" :state="errors['firstname'] ? 'invalid': ''"/>
                    <div v-if="errors['firstname']" class="invalid-tooltip">{{ errors['firstname'][0] }}</div>
                </b-form-group>
                <b-form-group :label="$t('email')" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                    <b-input type="text" :placeholder="$t('email')" v-model="email" :state="errors['email'] ? 'invalid': ''"/>
                    <div v-if="errors['email']" class="invalid-tooltip">{{ errors['email'][0] }}</div>
                </b-form-group>
                <b-form-group label="Lien vers les résultats" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                    <b-input type="text" placeholder="lien" v-model="softconcept" :state="errors['softconcept'] ? 'invalid': ''"/>
                    <div v-if="errors['softconcept']" class="invalid-tooltip">{{ errors['softconcept'][0] }}</div>
                </b-form-group>
                <b-form-group :label="$t('companies')" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                    <v-jstree
                            :data="treeData"
                            :class="{ 'tree-rtl': isRTL }"
                            show-checkbox
                            multiple
                            allow-batch
                            whole-row
                            draggable/>
                </b-form-group>
                <b-form-group :label="$t('user_type')" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                    <b-select plain v-model="user_type_id" :options="userTypeData"/>
                    <div v-if="errors['user_type_id']" class="invalid-tooltip">{{ errors['user_type_id'][0] }}</div>
                </b-form-group>
                <b-form-row>
                    <div class="col-md-10 ml-md-auto">
                        <b-btn type="submit" variant="primary">{{ $t('invite_user')}}</b-btn>
                    </div>
                </b-form-row>
            </b-form>
        </b-card>
    </div>
</template>
<style src="@/vendor/libs/vue-jstree/vue-jstree.scss" lang="scss"></style>
<script>
    import { ADMIN_GET_USERTYPES_REQUEST } from '../_store/administration/user/actiontypes'
    import {GET_COMPANIES_REQUEST, GET_HIERARCHICAL_COMPANIES_REQUEST} from '../_store/company/actiontypes';
    import {INVITE_USER_REQUEST, USER_REQUEST} from '../_store/user/actiontypes';
    import Breadcumb from '../components/breadcumb';
    import { mapState } from 'vuex';
    import VJstree from 'vue-jstree';

    function getChildrens(company) {
        return company.companies.map(children => {
            if (children.companies.length > 0){
                return {
                    'show-checkbox': false,
                    'text': children.name,
                    'id': children.id,
                    'selected': false,
                    'children': getChildrens(children),
                    'opened': false,
                }
            }
            else {
                return {
                    'show-checkbox': false,
                    'text': children.name,
                    'id': children.id,
                    'selected': false,
                    'children': [],
                    'opened': false,
                }
            }
        })
    }

    export default {
        name: 'adminCategoryAdd',
        components: { Breadcumb, VJstree },
        mounted() {
            this.breadcumbData = [
                { text: this.$t('welcome'), href: '/dashboard/' },
                { text: this.$t('users_list'), href: '/users/list/' },
                { text: this.$t('invite_user'), active: true }
            ];
            this.$store.dispatch(USER_REQUEST)
                .then(response => {
                    let user = response.data.user;
                    this.$store.dispatch(ADMIN_GET_USERTYPES_REQUEST)
                        .then(response => {
                            let userTypes = response.data.usertypes.map(userType => {
                                if (user.userprofile.user_type.position <= userType.position && userType.position <= 4){
                                    if (this.$cookie.get('language') === 'fr') {
                                        return {
                                            value: userType.id,
                                            text: userType.label
                                        };
                                    }
                                    else{
                                        return {
                                            value: userType.id,
                                            text: userType.label_en
                                        };
                                    }
                                }
                            });
                            this.userTypeData = userTypes.filter(userType => {
                                return userType !== null && userType !== undefined;
                            })
                        });
                })
           
            this.$store.dispatch(GET_HIERARCHICAL_COMPANIES_REQUEST)
                .then(response => {
                    this.treeData = response.data.hierarchical_companies.map(company => {
                        let childrens = [];
                        if (company.companies.length > 0){
                            childrens = getChildrens(company)
                        }
                        return {
                            'show-checkbox': true,
                            'text': company.name,
                            'id': company.id,
                            'children': childrens,
                            'opened': false,
                        }
                    });
                });
        },
        computed: mapState(
            {
                errors: state => state.admin_user.errors,
                user: state => state.user.user
            }),
        data() {
            return ({
                breadcumbData: [],
                companyData: [],
                companies: [],
                userTypeData: [],
                user_type_id: 0,
                company_id: 0,
                error: false,
                softconcept: '',
                email: '',
                lastname: '',
                firstname: '',
                treeData: [],
                duplicate_email: false,
            });
        },
        layout(context) {
            return 'layout';
        },
        methods: {
            addUser: function (e) {
                e.preventDefault();
                this.$store.dispatch(INVITE_USER_REQUEST, {
                    lastname: this.lastname,
                    firstname: this.firstname,
                    email: this.email,
                    companies: this.treeData,
                    user_type_id: this.user_type_id,
                    softconcept: this.softconcept
                })
                    .then(() => {
                        this.$router.push('/users/list/');
                    })
                    .catch((error) => {
                        if (error.error.user === 'noperimeter') {
                            this.error = this.$t('noperimeter')
                        } else if (error.error.email === 'duplicate'){
                            this.error = this.$t('duplicate_email')
                        }
                    });
            }
        }
    };
</script>
